import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import { teeTimeList } from '../../reducers/teeTimeList';
import { Button } from "../atoms/button";
import { Label } from "../atoms/label";
import { ModalClose } from "../atoms/modalClose";
import './../../resources/css/popup/popup.css';
import common from "../../resources/js/common/common"
import commonUtil from '../../common/commonUtil';

const GolfReservationPopupContainer = (props) => {
    const {
        state,
        onClickClosePopupWindow,
        setReserveCheckInfo,
    } = props;

    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    let footerClass = "";
    const popupRef = useRef(null);
    moment.locale('ja')

    footerClass = "reservation";

    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useLayoutEffect(() => {
        popupRef.current.scrollTop = 0;
    },[]);

    const onClose = () => {
        onClickClosePopupWindow();
        setPopupMessage('');
    }

    // 予約確認
    const onClickConfirm = (req) => {
        if(req.teeTimeList){
            req.teeTimeList.sort((data1, data2) => {
                let teetime1 = data1.teeTime;
                let hour1 = teetime1.slice(0, 2);
                let minute1 = teetime1.slice(2,4);
                teetime1 = hour1 + ":" + minute1;
                let teetime2 = data2.teeTime;
                let hour2 = teetime2.slice(0, 2);
                let minute2 = teetime2.slice(2,4);
                teetime2 = hour2 + ":" + minute2;
                teetime1 = Date.parse(`2000/01/01 ${teetime1}`);
                teetime2 = Date.parse(`2000/01/01 ${teetime2}`);
                return teetime1 - teetime2
            });
        }
        console.log(req.teeTimeList);
        setReserveCheckInfo(req);
        onClose();
        history.push("/reserve/golf/bookingConfirmDetaile")
    }

    const dateForm = (res) => {
        let date = res.substr(0, 4) + "年";
        if (res.substr(5, 1) === '0') {
            date = date + res.substr(6, 1) + "月";
        } else {
            date = date + res.substr(5, 2) + "月";
        }

        if (res.substr(8, 1) === '0') {
            date = date + res. substr(9, 1) + "日";
        } else {
            date = date + res. substr(8, 2) + "日";
        }
        
        return date;
    }

    return (
        <div ref={popupRef} className={state.golfReservationPopup ? "popupIsShow reservePopUpIsShow" : "popup"} id="js-popup">
            {/* <div className={isMobilePhone ? "popupInner_RTCC_reserveConfirm_media" : "popupInner_RTCC_reserveConfirm"}> */}
            <div className={isMobilePhone ? "popupInner_GOLF_reserveConfirm_media" : "popupInner_GOLF_reserveConfirm"}>
                <div className={isMobilePhone ? "popupSpHead" : "popupPcHead"}>
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClose()} />
                    <h4 className="golfPopup_innerText innerText" >予約確認・変更・キャンセル</h4>
                </div>
                <div style={{height:"67px"}}/>
                {popupMessage !== '' && popupMessage !== undefined ?  
                    <div style={style.message}> {popupMessage}</div>
                    : 
                    null
                }
                {
                    (state.popupDataList === undefined || state.popupDataList.length == 0 ) ?
                    <div className='noDataStyle'>
                        現在お預かりしているご予約はありません。
                    </div>
                    : null
                }
                {state.popupDataList ? state.popupDataList.map((value, index) => {
                    return <div key={"bookConfirm" + index} 
                                style={index === (state.popupDataList.length - 1) ? 
                                    {background:"#eeeeee96", padding:"30px 0px 60px 0px"}
                                    :
                                    {background:"#eeeeee96", padding:"30px 0px 30px 0px"}
                                }>
                        <div style={isMobilePhone ? style.tableMobile : style.table}>
                            <div key={"checkIn" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>お問合せ番号</div>
                                <div style={style.inline}>{value.reservationNo}</div>
                            </div>
                            <div key={"checkOut" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>プレー日</div>
                                <div style={style.inline}>{commonUtil.getStringFromDateJpnGolf(value.playDate)}</div>
                            </div>
                            <div key={"guestNum" + index} style={isMobilePhone ? style.tableRowSp : style.tableRowInfo}>
                                <div style={isMobilePhone ? style.tableColHeadingMob : style.tableColHeading}>ゴルフ場</div>
                                <div style={style.inline}>{value.golfCourseName}</div>
                            </div>
                            <div className="buttonArea3" style={{display:"flex",alignItems:"center",justifyContent:"center"}} >
                                <Button className="reservationConfirmBtn" buttonClassName="buttonText" onClick={() => onClickConfirm(value)} buttonText="予約内容を確認・変更・キャンセル" />
                            </div>
                        </div>
                    </div>
                })
                : null}
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};


const mapStateToProps = (state) => {
    return {
        // login: state.login,
        // checkIn: state.checkIn,
        // course: state.course,
        // keyWord: state.keyWord,
        // area: state.area,
        // startTime: state.startTime,
        // detailCondition: state.detailCondition,
        // favoriteCondition: state.favoriteCondition,
        // reserveInfo: state.reserveInfo,
        // toUserInputInfo: state.toUserInputInfo,
        // reserveCancelInfo: state.reserveCancelInfo,
        // stayInfo: state.stayInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
    };
}

const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerClose: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        backgroundColor: "#fff",
        zIndex: "2",
        height: "30%",
    },
    popupInnerMobile: {
        position: "absolute",
        left: "50%",
        bottom: "0%",
        transform: "translate(-50%, 0%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerText: {
        width: "100%",
        textAlign: "center",
    },
    popupInnerTextSp: {
        width: "100%",
        textAlign: "center",
        borderBottom: "1px solid #eee",
        margin: 0,
        padding: "20px 0px 20px 0px"
    },
    closeBtn: {
        position: "absolute",
        right: "15px",
        top: "0",
        width: "50px",
        height: "50px",
        lineHeight: "50px",
        textAlign: "center",
        cursor: "pointer",
        fontSize: "50px",
    },
    svg: {
        height: "20",
        width: "20",
    },
    message: {
        background:"#eeeeee96",
        whiteSpace: "pre-line",
        textAlign: "center",
        color: "#FF0000"
    },
    messageSave: {
        margin: "15% 0px",
        whiteSpace: "pre-line",
        textAlign: "center"
    },
    table: {
        display: "block",
        width: "70%",
        margin: "0px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        background:"white",
        marginBottom:"0px",
    },
    tableMobile: {
        display: "block",
        width: "90%",
        margin: "20px auto",
        borderCollapse: "collapse",
        marginBottom: "0px",
        background:"white",
        marginBottom:"0px",
    },
    tableImageRow: {
        display: "block",
        width: "100%",
        textAlign: "center"
    },
    tableTitle: {
        borderTop: "solid 1px rgb(173, 173, 173)"
    },
    tableRowSp: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "block",
        margin: "7px 10px",
        fontSize: "15px",
        letterSpacing:"1px",
    },
    tableRowInfo: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "block",
        fontSize: "15px",
        letterSpacing:"1px",
        margin: "0px 40px",
    },
    tableRowSave: {
        display: "block",
        borderBottom: "1px solid rgb(173, 173, 173)",
        padding: "10px",
        margin: "7px 10px",
        fontSize: "15px",
        letterSpacing: "1px",
        display:"flex",
        alignItems:"center",
    },
    tableRow: {
        display: "table-row",
        borderTop: "solid 1px rgb(173, 173, 173)",
        fontSize: "15px",
        letterSpacing:"1px",
    },
    blockStyle: {
        display: "block",
        borderTop: "solid 1px rgb(173, 173, 173)",
        fontSize: "15px",
        letterSpacing:"1px",
    },
    blockRow: {
        borderBottom: "solid 1px rgb(173, 173, 173)",
        padding: "10px",
        display: "table-row",
        fontSize: "15px",
        letterSpacing:"1px",
        margin: "7px 10px",
    },
    tableNone: {
        display: "block",
        fontSize: "15px",
        letterSpacing:"1px",
    },
    tableRow2: {
        padding: "10px",
        display: "block",
        fontSize: "15px",
        letterSpacing:"1px",
    },
    mobileRow: {
        display: "block",
        borderTop: "solid 1px rgb(173, 173, 173)"
    },
    mobileRowSava: {
        display: "block",
        display:"flex",
        alignItems:"center",
        borderTop: "solid 1px rgb(173, 173, 173)"
    },

    tableRowLast: {
        display: "table-row",
    },
    mobileRowLast: {
        display: "block",
    },
    mobileRowLastSave: {
        display:"flex",
        alignItems:"center",
    },
    deleteButton: {
        textAlign: "right",
        width: "90%",
        margin: "0px 0px 30px 0px"
    },
    tableColHeading: {
        display: "inline-block",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontSize: "small",
        width: "20%"
    },
    tableColHeadingSave: {
        display: "inline-block",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "20px",
        paddingBottom: "20px",
        fontSize: "small",
        width: "33%"
    },
    tableColHeadingSp: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingBottom: "30px",
        fontSize: "small",
        width: "33%"
    },
    tableColHeadingMob: {
        fontWeight: "bold",
        fontSize: "small",
        marginBottom:"5px"
    },
    inline:{
        display:"inline-block",
        fontSize: "small",
    },
    tableColHeadingInfo: {
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "30px",
        fontSize: "small",
        width: "80%"
    },
    tableColHeadingTitle: {
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "serif",
        paddingTop: "30px",
        paddingBottom: "20px",
        fontSize: "large",
        width: "100%",
    },
    mobileColHeadingTitle: {
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "serif",
        paddingTop: "30px",
        paddingBottom: "20px",
        fontSize: "middle",
        width: "100%",
    },
    mobileColHeading: {
        fontWeight: "bold",
        paddingRight: "20px",
        paddingTop: "30px",
        paddingBottom: "30px",
        fontSize: "small",
        width: "100%"
    },
    mobileColHeadingSave: {
        fontWeight: "bold",
        paddingRight: "20px",
        paddingTop: "15px",
        paddingBottom: "15px",
        fontSize: "small",
        width: "33%"
    },
    mobileSaveText:{
        width:"67%"
    },
    tableColBody: {
        fontSize: "small",
    },
    tableColBody2: {
        fontSize: "small",
        paddingBottom:"20px",
    },
    tableColBodyHotel: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace: "pre-line",
        overflowWrap: "anywhere"
    },
    tableColHeadingLast: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "30px",
        paddingBottom: "40px",
        fontSize: "small",
    },
    tableColBodyLast: {
        display: "table-cell",
        paddingTop: "40px",
        paddingBottom: "40px",
        fontSize: "small",
    },
    tableColBodyLastSp: {
        // display: "table-cell",
        paddingTop: "40px",
        fontSize: "small",
    },
    imageRow: {
        width: "70%",

    },
    image: {
        display: "block",
        width: "100%",
        marginLeft: "0%",
        marginRight: "0%",
        marginBottom: "10%",
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    buttonArea: {
        width: "60%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "40px",
    },
    closeButtonArea: {
        width: "60%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // height: "50%",
    },
    buttonAreaMobile: {
        width: "90%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "15px",
    },
    button: {
        width: "100%",
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "15px 120px 15px 120px",
        cursor: "pointer",
    },
    buttonSearch: {
        width: "100%",
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "12px 120px",
        backgroundPosition: 'left 25% bottom 45%',
        backgroundSize: '60% 60%',
        backgroundRepeat: "no-repeat",
        fontSize: "small",
        cursor: "pointer"
    },
    deleteCriteria: {
        color: "#adadad",
        textAlign: "right",
        textDecoration: "underline",
        fontSize: "small",
        cursor: "pointer",
    },
    iconPin: {
        width: "24px",
        height: "30px",
        paddingRight: "2px"
    },
    iconCar: {
        width: "24px",
        height: "20px",
        paddingRight: "2px"
    }
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfReservationPopupContainer);